export default "__VITE_ASSET__cba72af6__"